<div
  data-testid="event-cutoff"
  class="pointer-events-none absolute inset-x-0 z-1"
  [style.top.px]="offsetPx()"
  [style.bottom.px]="0"
  [style.background]="zoneFill()"
  [style.border-top]="'1.5px dashed ' + ink()"></div>

<span
  data-testid="event-cutoff-time"
  class="pointer-events-none absolute right-0.5 z-2 -translate-y-1/2 rounded-xs px-1 font-mono text-[9.5px] leading-snug font-semibold"
  [style.top.px]="offsetPx()"
  [style.color]="'var(--bg-elevated)'"
  [style.background]="timeFill()">
  {{ time() | date: 'HH:mm' }}
</span>
